module.exports = __webpack_public_path__ + "img/Patch5.ab09a59e.webp";